import { render, staticRenderFns } from "./admin-modelModal.vue?vue&type=template&id=3f0ec7cc&"
import script from "./admin-modelModal.vue?vue&type=script&lang=js&"
export * from "./admin-modelModal.vue?vue&type=script&lang=js&"
import style0 from "./admin-modelModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports